import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pz-count-up',
    templateUrl: './count-up.component.html',
    styleUrls: ['./count-up.component.scss']
})
export class CountUpComponent implements OnInit {
    @Input()
    public myEndVal: number;
    @Input()
    public title: string;
    @Input()
    public percent: number;

    public constructor() {
        //
    }

    public ngOnInit() {
        this.myEndVal = 0;
    }

}
